import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, AuthenticationService, HomeService,Challenge } from '../../_services';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

@Component({
  selector: 'app-edit-challenge',
  templateUrl: './edit-challenge.component.html',
  styleUrls: ['./edit-challenge.component.scss']
})
export class EditChallengeComponent implements OnInit {

   challengeForm: FormGroup;
    submitted = false;
    loading = false;
    name = 'Angular 4';
    urls = [];
    categories = [];
	loading_component="";
  projectid = '';
  project_info = [];
   visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  criterias=null;
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.criterias.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(criteria): void {
    const index = this.criterias.indexOf(criteria);

    if (index >= 0) {
      this.criterias.splice(index, 1);
    }
  }  
  
    constructor(private router: Router, private formBuilder: FormBuilder, private challengeService: Challenge, private route: ActivatedRoute, private alertService: AlertService, private homeService: HomeService) { }

  
  ngOnInit() {
    this.projectid = this.route.snapshot.paramMap.get('id');

    this.challengeForm = this.formBuilder.group({
        projectTitle: ['', Validators.required],
        projectShortDescription: ['', Validators.required],
        projectDescription: ['', Validators.required],
        project_category_id: ['', Validators.required],
        projectLocation: ['', Validators.required],
        projectBudget: ['', Validators.required],
        projectDuration: ['', Validators.required]
    });
    this.getCategory();
    this.projectInfo();
  }

  projectInfo() {
    this.challengeService.getById(this.projectid).pipe(first()).subscribe((project: any) => {
      if(project.status=='ok') {
        this.project_info = project.result_set;
        this.challengeForm.setValue({
          projectTitle: project.result_set.project_title,
          projectShortDescription: project.result_set.project_short_description,
          projectDescription: project.result_set.project_description,
          project_category_id: project.result_set.category_id,
          projectLocation: project.result_set.project_location,
          projectBudget: project.result_set.project_fund,
          projectDuration: project.result_set.project_duration
        });
        if(project.result_set.project_skill_set!='') {
          this.criterias = project.result_set.project_skill_set;
        }
      }
    });
  }

  getCategory() {
    this.homeService.getAllCategories().pipe(first()).subscribe((data: any) => {
      if(data.status=='ok') {
        this.categories = data.result_set;
      }
    });
  }

  get f() { return this.challengeForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.loading = true;
    this.loading_component = "place-proposals-loading";
    // stop here if form is invalid
    if (this.challengeForm.invalid) {
      this.loading = false;
      this.loading_component = "";
      return;
    }else{
      //api call
	    const formData = new FormData();
      formData.append('project_id', this.projectid);
      formData.append('project_title', this.f.projectTitle.value);
      formData.append('project_short_description', this.f.projectShortDescription.value);
      formData.append('project_description', this.f.projectDescription.value);
      formData.append('project_category_id', this.f.project_category_id.value);
      formData.append('project_location', this.f.projectLocation.value);
      formData.append('project_fund', this.f.projectBudget.value);
	    formData.append('project_duration', this.f.projectDuration.value);
      formData.append('project_skill_set', this.criterias);
          
  	  this.challengeService.editChallenge(formData).pipe(first()).subscribe((data: any) => {
        if(data.status=='ok') {
          this.alertService.success(data.message, true);
          this.loading = false;
          this.loading_component = "";
  	      this.router.navigate(['challenge/upload/'+this.projectid]);
        } else {
          this.loading = false;
          this.loading_component = "";
  	      this.alertService.error(data.message, true);
  	   
        }
      }, error => {
        this.alertService.error(error, true); 
        this.loading = false;
        this.loading_component = "";
      });
    }
  }

  SkipSubmit() {
    this.submitted = true;
    this.loading = true;
    this.loading_component = "place-proposals-loading";
    // stop here if form is invalid
    if (this.challengeForm.invalid) {
      this.loading = false;
      this.loading_component = "";
      return;
    }else{
      //api call
      const formData = new FormData();
      formData.append('project_id', this.projectid);
      formData.append('project_title', this.f.projectTitle.value);
      formData.append('project_description', this.f.projectDescription.value);
      formData.append('project_category_id', this.f.project_category_id.value);
      formData.append('project_location', this.f.projectLocation.value);
      formData.append('project_fund', this.f.projectBudget.value);
      formData.append('project_duration', this.f.projectDuration.value);
          
      this.challengeService.editChallenge(formData).pipe(first()).subscribe((data: any) => {
        if(data.status=='ok') {
          this.alertService.success(data.message, true);
          this.loading = false;
          this.loading_component = "";
          this.router.navigate(['my-challenges']);
        } else {
          this.loading = false;
          this.loading_component = "";
          this.alertService.error(data.message, true);
       
        }
      }, error => {
        this.alertService.error(error, true); 
        this.loading = false;
        this.loading_component = "";
      });
    }
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();

          reader.onload = (event:any) => {
            console.log(event.target.result);
             this.urls.push(event.target.result); 
          }

          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }
}
